import { render } from "./RuiTabs.vue?vue&type=template&id=576cd180&scoped=true"
import script from "./RuiTabs.vue?vue&type=script&lang=ts"
export * from "./RuiTabs.vue?vue&type=script&lang=ts"

import "./RuiTabs.vue?vue&type=style&index=0&id=576cd180&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-576cd180"

export default script